
import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client/react";
import { apolloClient } from "./apollo-client";
import { AuthProvider } from "./auth-provider";
import { ConfirmProvider, PromptProvider } from "@clearpath/design-system";
import { App } from "./app";
// 2026-05-01: design-system tokens + dark default unified across SPAs.
import "@clearpath/design-system/tokens.css";
import "./styles.css";

if (typeof document !== "undefined") {
  document.body.dataset.mode = "dark";
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <ApolloProvider client={apolloClient}>
        <ConfirmProvider>
              <PromptProvider>
          <App />
        </PromptProvider>
            </ConfirmProvider>
      </ApolloProvider>
    </AuthProvider>
  </React.StrictMode>,
);
